export enum IdempotencyOperationType {
  Transfer = 'TRANSFER',
  Payment = 'PAYMENT',
  SwiftTransfer = 'SWIFT_TRANSFER',
  RecurringPayment = 'RECURRING_PAYMENT',
  Tax = 'TAX',
  CurrencyExchange = 'CURRENCY_EXCHANGE',
  CheckbookRequest = 'CHECKBOOK_REQUEST',
  CardRecharge = 'CARD_RECHARGE',
}

export interface IdempotencyKeyResponse {
  key: string;
  operationType: IdempotencyOperationType;
  expiresAt: string;
}
